import { createSlice } from '@reduxjs/toolkit'
import { setItem, clear } from '../utils/localStorage'

export const authSlice = createSlice({
    name: 'authen',
    initialState: {
        isLogin: false,
        data: {
            access_token: '',
            userData: {}
        }
    },
    reducers: {
        loginAction: (state, action) => {
            // Hỗ trợ nhiều định dạng payload từ API
            const payload = action.payload || {};
            const token = payload.token || payload.access_token || (payload.data && payload.data.access_token) || '';
            const user = payload.user || (payload.data && payload.data.user) || payload.userData || {};
            const roles = user?.roles || payload.roles || [];

            setItem('isLogin', true);
            if (token) setItem('access_token', JSON.stringify(token));
            setItem('userData', JSON.stringify(user));
            setItem('roles', JSON.stringify(roles));

            return {
                ...state,
                isLogin: true,
                data: {
                    access_token: token,
                    userData: { ...user, roles }
                }
            };
        },
        logoutAction: (state) => {
            clear()
            return {
                ...state,
                isLogin: false,
                data: {
                    access_token: '',
                    userData: {}
                }
            }
        },
        userLoaderAction: (state, action) => {
            const user = action.payload.user || state.data.userData
            setItem('userData', JSON.stringify(user))
            setItem('roles', JSON.stringify(user?.roles || []))
            return {
                ...state,
                isLogin: true,
                data: {
                    access_token: action.payload.access_token || state.data.access_token,
                    userData: user,
                }
            };
        }
    },
})
export const { loginAction, logoutAction, userLoaderAction } = authSlice.actions
export default authSlice.reducer
